import styled from 'styled-components';
import { Select } from 'antd';

export const CompanyEditActionButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
`;

export const SelectManagers = styled(Select)`
  .anticon {
    line-height: 0 !important;
  }
`;
